// 英文

export default {
  "环球客": "GLOBAL STRINGERS",
  "登录": "Log in",
  "邮箱": "Email address",
  "密码": "Password",
  "忘记密码": "Forgot Password",
  "请确认已达法定成年年龄": "Please confirm that you have reached the legal age of majority.",
  "我已阅读并同意": "I have read and agree to the",
  "服务条款": "Terms of Service",
  "和": "and",
  "隐私政策": "Privacy Policy",
  "隐私协议": "Privacy Policy",
  "使用Google": "Continue with Google",
  "使用Facebook": "Continue with Facebook",
  "邮箱加入": "Join with emall",
  "没有账号?": "Don't have an account？",
  "加入": "Sign up",
  "注册": "Register",
  "无数据": "No Data",
  "国家": "Country",
  "省份": "Province",
  "城市": "City",
  "请输入姓名": "Please enter name",
  "请输入账号": "Please enter account",
  "请输入邮箱": "Please enter email",
  "请输入邮箱验证码": "Please enter email verify code",
  "请输入密码": "Please enter password",
  "请再次输入密码": "Please confirm password",
  "获取验证码": "Verify code",
  "已有账号? 点击登录": "Account exist? Click login",
  "已有账号?": "Already have an account?",
  "点击登录": "Log in",
  "APP下载": "Download APP",
  "关于我们": "About Us",
  "常见问题": "FAQ",
  "联系我们": "Contact Us",
  "立即开始": "Get Started",

  "姓名不能为空": "Name cannot be empty",
  "地区不能为空": "Region cannot be empty",
  "账号不能为空": "Account cannot be empty",
  "邮箱不能为空": "Email cannot be empty",
  "邮箱格式不正确": "Email format is incorrect",
  "验证码发送成功": "Verification code sent successfully",
  "邮箱已注册": "Email registered",
  "验证码不能为空": "Verification code cannot be empty",
  "密码不能为空": "Password cannot be empty",
  "两次密码不一致": "Two passwords are inconsistent",
  "密码规则": "The password must be at least 8 characters and no more than 32 characters. It must include numbers, uppercase letters, and lowercase letters at the same time",

  "请确认勾选已达法定年龄": "Please confirm that you have reached the legal age",
  "请确认勾选同意协议": "Please confirm that you have agreed to the agreement",

  "登录成功": "Login successful",
  "登录失败": "Login failed",
  "登出成功": "Logout successful",
  "登出失败": "Logout failed",

  "注册成功": "Registration successful",
  "注册成功，请重新登录": "Registration successful, please log in again",

  "服务器错误": "Server error",
  "服务器错误，请重试": "Server error, please try again",


  "发送失败提示消息": "Send failed, please try again",

  "标题": "Title",
  "请输入标题": "Please enter title",
  "简介": "Introduction",
  "请输入简介": "Please enter introduction",
  "视频上传": "Video upload",
  "视频上传限制信息": "It is recommended to use MP4/MOV video format, and the video length shall not exceed 1 hour",
  "视频上传大小限制信息": "The video cannot exceed 30G",
  "视频上传数目限制信息": "Only 9 videos can be uploaded at most",
  "替换视频": "Replace video",
  "图片上传": "Image upload",
  "封面图": "Cover image",
  "封面图限制信息": "Recommended size 16*9, supported format JPG/JPEG/PNG, less than 5M",
  "封面图上传大小限制信息": "Cover image less than 5M",
  "选择标签": "Select tag",
  "请选择标签": "Please select tag",
  "所属地区": "Region",
  "国家": "Country",
  "省份": "Province",
  "城市": "City",
  "上传附件": "Upload attachment",
  "点击插入附件": "Click to insert attachment",
  "关联任务": "Related tasks",
  "更换": "Replace",
  "添加关联任务": "Add related tasks",
  "同意签署": "Agree to sign",
  "著作权转让协议": "Copyright transfer agreement",
  "保存草稿": "Save draft",
  "提交": "Submit",
  "上传成功": "Upload successful",
  "上传失败": "Upload failed",
  "必填项未填写提示信息": "Required items not filled in",
  "上传中": "Uploading...",

  "创建成功": "Created successfully",
  "创建失败提示信息": "Created failed, please try again",

  "状态": "Status",
  "全部": "All",
  "待审核": "Pending",
  "审核退回": "Send Back",
  "审核通过": "Accepted",
  "审核中": "Pending",
	"未接收": "Unaccepted",
	"未支付": "Unpaied",
	"已通过": "Passed",
	"已拒绝": "Rejected",
	"已接收": "Accepted",
	"已支付": "Paid",
	"已提交": "Submitted",
	"已驳回": "Send Back",
	"已采纳": "Accepted",
	"已发布": "Issued",
	"Pending": "Pending",
  "已打款": "Paid",

  "封面": "Cover",
  "标题": "Title",
  "内容标签": "Content Tags",
  "关联活动": "Activities",
  "提交时间": "Submit Time",
  "状态": "Status",
  "审核时间": "Review Time",
  "操作": "Operation",

  "编辑": "Edit",
  "删除": "Delete",
  "查看详情": "View details",
  "作品ID不存在": "Work ID does not exist",
  "删除成功": "Deleted successfully",
  "删除失败，请重试": "Deleted failed, please try again",

  "提示": "Prompt",
  "确认": "Confirm",
  "确定": "Confirm",
  "取消": "Cancel",
  "确认删除该作品": "Confirm to delete this work?",

  "选择任务": "Select Task",
  "加载更多": "Load More",
  "没有更多了": "No More",
  "暂无数据": "No Data",
  "加载中": "Loading...",
  "加载中新": "Loading",

  "账号设置": "Account Settings",
  "认证情况": "Authentication",
  "昵称": "Nickname",
  "账号": "Account",
  "邮箱": "Email",
  "姓名": "Name",
  "简介": "Introduction",
  "标签": "Tags",

  "修改头像": "Modify avatar",
  "未提交认证": "Not submitted for certification",
  "认证通过": "Certification passed",
  "认证失败": "Certification failed",
  "去认证": "Certification",

  "修改": "Modify",
  "设置": "Set",
  "最多5个标签": "Up to 5 tags",
  "头像设置要求": "The size is 200*200 pixels, which can represent the image of an individual, organization or brand. Please do not use vulgar pictures, QR codes, or avatars of other organizations and enterprises that may mislead users",
  "个人简介要求": "1 to 140 characters",

  "修改简介": "Modify profile",
  "修改简介说明": "Describe the location of the account or the author's profile to the readers. The profile will be displayed on the media homepage. Please do not publish personal mobile phone numbers, email addresses, advertising and marketing information. Please do not exceed 100 words",
  "播放视频": "Play video",

  "谷歌登录错误提示信息一": "The login window is not displayed. The pop-up window may be blocked by the browser, or there may be other configuration issues.",
  "谷歌登录错误提示信息二": "The user skipped the login. Please try again.",
  "谷歌登录错误提示信息三": "An unknown error occurred during login. Please try again later.",

	"Pending": "Pending",
  "作品详情": "作品详情",
  "审核中": "Pending",
  "未接收": "Unaccepted",
  "未支付": "Unpaied",
	"已通过": "Passed",
	"已拒绝": "Rejected",
	"已接收": "Accepted",
	"已支付": "Paid",
  "已提交": "Submitted",
	"已驳回": "Send Back",
	"已采纳": "Accepted",
	"已发布": "Issued",
  "退回待编": "Send Back",

  "下载审核意见附件": "Download audit opinion attachment",
  "标签": "Tag",
  "附件": "Attachment",
  "修改成功": "Successful modification",
  "修改失败提示信息": "Failed modification, please try again",

  "开始截止时间": "Start Deadline",
  "截止时间": "Deadline",
  "剩余天数": "Remaining Days",
  "任务积分": "Task Points",
  "任务状态": "Task Status",
  "天": "Days",
  "已上架": "Listed",
  "已下架": "Delisted",
  "上传作品": "Upload Works",

  "提交线索": "Submit Clues",
  "我的线索": "My Clues",
  "确认删除该线索": "Confirm to Delete the Clue",

  "线索详情": "Clue details",

  "著作权转让协议": "Copyright transfer agreement",

  "个人主页": "Home",
  "EN": "EN",
  "中": "ZH",
  "退出登录": "Log out",

  "创作": "Creation",
  "作品发布": "Publish Work",
  "我的作品": "My work",
  "作品详情": "Work details",
  "任务": "Task",
  "我的任务": "My task",
  "任务详情": "Task details",
  "线索": "Clue",
  "提交线索": "Submit clue",
  "我的线索": "My clue",
  "线索详情": "Clue details",
  "设置": "Settings",

  "认证提交成功": "Certification submitted successfully",
  "我们已收到您的认证信息，感谢您提交认证": "We have received your certification information, thank you for submitting the certification",
  "关闭": "Close",
  "认证信息": "Certification information",
  "邮箱": "Email",
  "姓名": "Name",
  "出生年月": "Date of birth",
  "选择日期": "Select date",
  "上传简历": "Upload resume",
  "仅支持文件格式": "*Only support doc/txt/pdf format files",
  "所在地": "Location",
  "确认": "Confirm",
  "设置姓名": "Set name",
  "修改昵称": "Modify nickname",
  "现昵称": "Nickname",
  "新昵称": "New nickname",
  "请输入昵称": "Please enter nickname",
  "不超过32个字符，不能含有特殊符号、空格": "No more than 32 characters, no special symbols or spaces",
  "新标签": "New tag",

  "寻找拍客": "Find photographers",
  "在全球118个国家寻找适合您的专业拍客，发布您的拍摄任务，管理任务进度请联系": "Find professional photographers suitable for you in 118 countries around the world, publish your shooting tasks, and please contact us to manage the progress of tasks",
  "成为拍客": "Become photographer",
  "与更多品牌合作，展示你的创意": "Cooperate with more brands and show your creativity",
  "登录/注册": "Login/Register",

  "消息": "Messages",
  "环球客客服": "Customer Service",
  "系统消息": "System Message",
  "按下Enter发送内容/ Ctrl+Enter换行": "Press Enter to send the content / Ctrl+Enter to wrap the line",

  "用户政策": "Terms of Use",
  "隐私策略": "Privacy Policy",

  "找回密码": "Retrieve password",
  "已有账号": "Already have an account?",

  "标签设置成功": "Label set successfully",
  "标签设置失败": "Label setting failed",
  "头像设置成功": "Avatar setting successful",
  "头像设置失败": "Avatar setting failed",
  "昵称设置成功": "Nickname setting successful",
  "昵称设置失败": "Nickname setting failed",
  "姓名设置成功": "Name setting successful",
  "姓名设置失败": "Name setting failed",
  "简介设置成功": "Introduction setting successful",
  "简介设置失败": "Introduction setting failed",

  "密码重置成功": "Password reset successful",
  "密码重置失败": "Password reset failed",

  "未认证": "Not certified yet",
  "已提交认证": "Submitted for certification",
  "再次认证": "Recertification",
  "认证成功": "Authentication Success",
  "认证未通过": "Certification failed",

  "老用户提示信息": "Please retrieve password",
  "验证码错误": "Verification code error",

  "裁剪图片": "Crop Image",

  "京ICP备2023005886号-3": "Copyright © Beijing Have Your Say Cultural Media Co., Ltd.",

  "保存草稿箱成功": "Save draft box successfully",
  "保存草稿箱失败": "Failed to save drafts",
  "更新草稿箱成功": "Update draft box successfully",
  "更新草稿箱失败": "Update draft box failed",
  "草稿箱": "Draft Box",

  "在此登录": "Sign In here",
  "在此注册": "Sign Up here",
  "系统通知": "System Notifications",
  "系统通知引导内容": `Receive information from the\nplatform, e.g. projectsubmission\nresults, etc..`,
  "客户服务": "Customer Service",
  "客户服务引导内容": "For any questions, please contact us here.",
  "上传视频": "Upload Video",
  "上传视频引导内容": "Share your high-quality video content with us.",
  "探索任务": "Explore Tasks",
  "探索任务引导内容": "Explore the latest tasks, complete it and get rewarded.",
  "分享线索": "Share clues",
  "分享线索引导内容": "Provide clues to stories, news,etc. that you find valuable.",
  "点击标题查看详情": "Click Title to view event details",
  "为本次活动做出贡献": "Contribute to this Event",
  "生成缩略图失败": "Failed to generate thumbnail",
  "立即投稿": "Submit Now",
  "正文": "Text",
  "请输入正文": "Please enter the network disk storage link containing videos/pictures/text or other files",
  "不存在可下载文件": "No file can donwload",
  "文件链接不存在，请重试": "File does not exist, please try again",
  "下载失败": "Download failed",
  "跳转路径不存在": "Route does not exist",
  
  "视频类型": "Video Types",
  "公告消息": "Announcement Message"
}
